import { Box, Divider } from '@mui/material';
import { useState } from 'react';
import { useToastProvider } from '../../shared/ToastProvider';
import SMModal from '../../shared/SMModal';
import { List } from '@mui/material';
import { PhaseLinksListItem } from './PhaseLinksListItem';
import {
  clearLinksModalMessages,
  fetchDeleteLink,
  fetchEditLink
} from './linksSlice';
import { useDispatch } from 'react-redux';
import { EditEntityModal } from '../../shared/EditEntityModal';
import { LINKS_TITLE } from '../../shared/AppConstants';

export const PhaseLinksList = ({ linkData, userInfoMap }) => {
  const linksArray = Object.values(linkData);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [entityToEdit, setEntityToEdit] = useState(null);
  const [entityToDelete, setEntityToDelete] = useState(null);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const dispatch = useDispatch();
  const { enqueueToast } = useToastProvider();

  const editEntity = (e, entity) => {
    dispatch(clearLinksModalMessages());
    e.preventDefault();
    setEntityToEdit(entity);
    setShowModalEdit(true);
  };

  const handleModalEditCancel = () => {
    setShowModalEdit(false);
  };

  const handleModalEditConfirm = (link) => {
    return dispatch(fetchEditLink(link));
  };

  const removeEntity = (e, entity) => {
    e.preventDefault();
    setShowModalDelete(true);
    setEntityToDelete(entity);
  };

  const handleModalDeleteCancel = () => {
    setShowModalDelete(false);
  };

  const handleModalDeleteConfirm = () => {
    setShowModalDelete(false);
    dispatch(fetchDeleteLink(entityToDelete.linkId)).then((response) => {
      if (response.type === 'links/delete/fulfilled') {
        enqueueToast({
          variant: 'success',
          message: 'Link deleted successfully'
        });
      }
    });
  };

  return (
    <>
      <Box>
        <List disablePadding>
          {linksArray.length > 0 && <Divider />}
          {linksArray.map((link, index) => {
            return (
              <>
                <PhaseLinksListItem
                  link={link}
                  isReadOnly={false}
                  userInfoMap={userInfoMap}
                  editEntity={editEntity}
                  removeEntity={removeEntity}
                />
                {index !== linksArray.length - 1 && <Divider />}
              </>
            );
          })}
        </List>
      </Box>
      {showModalEdit && entityToEdit && (
        <EditEntityModal
          showModal={showModalEdit}
          handleCancel={handleModalEditCancel}
          entityToEdit={entityToEdit}
          setEntityToEdit={setEntityToEdit}
          handleEntityUpdateLogic={handleModalEditConfirm}
          entityName={LINKS_TITLE}
          dispatch={dispatch}
          entityType={'link'}
        />
      )}
      <SMModal
        showModal={showModalDelete}
        handleCancel={handleModalDeleteCancel}
        handleYes={handleModalDeleteConfirm}
        title={`Delete Link`}
        msg_line1={`Are you sure you want to delete this Link?`}
        msg_line2=""
        cancelText="Cancel"
        yesText={`Delete Link`}
        id={entityToDelete}
      />
    </>
  );
};
